import * as React from "react";
import {useState} from "react";
import SettingCard, {ISettingCard} from "../../../../../../../../ui/settingcard/settingcard";
import DotIndicator from "../../../../../../../../ui/dotindicator/dotindicator";
import HorizontalDivider from "../../../../../../../../ui/horizontaldivider/horizontaldivider";
import "./tab1.scss";
import NormalSocialMediaCard, {
    INormalSocialMediaCard
} from "../../../../../../../../ui/socialmediacard/normal/normalsocialmediacard";
import {DropDownItem} from "../../../../../../../../modals/types/dropdown";
import Dropdown from "../../../../../../../../ui/dropdown/dropdown";
import HalfCircleProgressBar from "../../../../../../../../ui/halfcircleprogressbar/halfCircleProgressBar";
import HalfAccordionCard from "../../../../../../../../ui/halfcoloraccordion/halfcoloraccordion";

const Tab1 = () => {
    const [activateAd, setActivateAd] = useState("setting0");
    const [activateSocial, setActivateSocial] = useState("setting0");
    const [activateTypeContent, setActivateTypeContent] = useState("setting0");
    const [activateSocialMedia, setActivateSocialMedia] = useState("card0");
    const adSettingItems: ISettingCard[] = [
        {
            title: "بازدیدی",
            body: "متن تستی برای توضیحات",
            id: 0,
            activate: activateAd,
            setActivate: setActivateAd
        },
        {
            title: "اینفلوینسری و تعرفه ای",
            body: "متن تستی برای توضیحات",
            id: 1,
            activate: activateAd,
            setActivate: setActivateAd
        }
    ]
    const socialSettingItems: ISettingCard[] = [
        {
            title: "اینستاگرام",
            body: "متن تستی برای توضیحات",
            id: 0,
            activate: activateSocial,
            setActivate: setActivateSocial
        },
        {
            title: "تلگرام",
            body: "متن تستی برای توضیحات",
            id: 1,
            activate: activateSocial,
            setActivate: setActivateSocial
        }
    ]
    const contentTypeSettingItems: ISettingCard[] = [
        {
            title: "پست",
            body: "متن تستی برای توضیحات",
            id: 0,
            activate: activateTypeContent,
            setActivate: setActivateTypeContent
        },
        {
            title: "پست فورواردی",
            body: "متن تستی برای توضیحات",
            id: 1,
            activate: activateTypeContent,
            setActivate: setActivateTypeContent
        }
    ]
    const dailyMoneyAutoCompleteItems: DropDownItem[] = [
        {label: "1 میلیون تومان"}, {label: "2 میلیون تومان"}, {label: "5 میلیون تومان"}, {label: "10 میلیون تومان"}
    ];
    const socialMediaItems: INormalSocialMediaCard[] = [
        {
            image: require("../../../../../../../../assets/images/avatars/Avatar3.png"),
            name: "متی حیدری",
            id: "@vidomovoe",
            follower: "فالور : ۳ میلیون",
            places: ["سینما، تلویزیون و تئاتر", "عكاسی و فیلم", "عكاسی و فیلم", "مادر و کودک"],
            cardID: 0,
            activateSocialMedia: activateSocialMedia,
            setActivateSocialMedia: setActivateSocialMedia
        },
        {
            image: require("../../../../../../../../assets/images/avatars/Avatar4.png"),
            name: "امل",
            id: "@vidomovoe",
            follower: "فالور : ۵ میلیون",
            places: ["سینما، تلویزیون و تئاتر", "عكاسی و فیلم", "عكاسی و فیلم", "مادر و کودک"],
            cardID: 0,
            activateSocialMedia: activateSocialMedia,
            setActivateSocialMedia: setActivateSocialMedia
        },
        {
            image: require("../../../../../../../../assets/images/avatars/Avatar5.png"),
            name: "شهرزاد عاصمی",
            id: "@vidomovoe",
            follower: "فالور : ۵ میلیون",
            places: ["سینما، تلویزیون و تئاتر", "عكاسی و فیلم", "عكاسی و فیلم", "مادر و کودک"],
            cardID: 0,
            activateSocialMedia: activateSocialMedia,
            setActivateSocialMedia: setActivateSocialMedia
        },
        {
            image: require("../../../../../../../../assets/images/avatars/Avatar6.png"),
            name: "صدف بیوتی",
            id: "@vidomovoe",
            follower: "فالور : ۲ میلیون",
            places: ["سینما، تلویزیون و تئاتر", "عكاسی و فیلم", "عكاسی و فیلم", "مادر و کودک"],
            cardID: 0,
            activateSocialMedia: activateSocialMedia,
            setActivateSocialMedia: setActivateSocialMedia
        },
    ]
    return (
        <div className="Tab1">
            <div className="row pt-3">
                <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                    <DotIndicator size={"16px"}/>
                    <span>نوع تبلیغ</span>
                </div>
                {
                    adSettingItems.map((adSettingItem, index) => {
                        return (
                            <div className="col-lg-5 col-md-6 col-12 mb-2">
                                <SettingCard activate={adSettingItem.activate} title={adSettingItem.title}
                                             body={adSettingItem.body}
                                             setActivate={adSettingItem.setActivate} id={index}/>
                            </div>
                        );
                    })
                }
            </div>
            <HorizontalDivider/>
            <div className="row pt-3">
                <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                    <DotIndicator size={"16px"}/>
                    <span>شبکه های اجتماعی</span>
                </div>
                {
                    socialSettingItems.map((socialSettingItem, index) => {
                        return (
                            <div className="col-lg-5 col-md-6 col-12 mb-2">
                                <SettingCard activate={socialSettingItem.activate} title={socialSettingItem.title}
                                             body={socialSettingItem.body}
                                             setActivate={socialSettingItem.setActivate} id={index}/>
                            </div>
                        );
                    })
                }
            </div>
            <HorizontalDivider/>
            <div className="row pt-3">
                <div className="d-flex align-items-center pt-3 pb-2 mb-4">
                    <DotIndicator size={"16px"}/>
                    <span>نوع محتوا</span>
                </div>
                {
                    contentTypeSettingItems.map((typeSettingItem, index) => {
                        return (
                            <div className="col-lg-5 col-md-6 col-12 mb-2">
                                <SettingCard activate={typeSettingItem.activate} title={typeSettingItem.title}
                                             body={typeSettingItem.body}
                                             setActivate={typeSettingItem.setActivate} id={index}/>
                            </div>
                        );
                    })
                }
            </div>
            <HorizontalDivider/>
            <div className="row pt-5">
                <div className="d-flex align-items-center pt-3 pb-2 mb-2">
                    <DotIndicator/>
                    <span>تعیین بودجه</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-4 pb-1">بودجه ( تومان )</h6>
                    <Dropdown items={dailyMoneyAutoCompleteItems} placeHolder={"انتخاب کنید"}/>
                </div>
                <div
                    className="col-lg-6 col-md-6 col-12 mb-3 d-flex justify-content-lg-end justify-content-md-center justify-content-center">
                    <div className="Progress-Bar-Box-Container">
                        <HalfCircleProgressBar currentValue={200000} minValue={100000} maxValue={500000}/>
                        <div className="Progress-Bar-Box-Container-Text">
                            <img
                                src={require("../../../../../../../../assets/images/icons/RoundedGreenTick.svg").default}
                                alt="" className="img-fluid"/>
                            <span className="align-middle">تبلیغ شما حدودا در ۸ پیج نمایش داده خواهد شد</span>
                        </div>
                    </div>
                </div>
                <HalfAccordionCard custom={true}/>
            </div>
            <div className="row py-5">
                {
                    socialMediaItems.map((socialMediaItem, index) => {
                        return (
                            <div key={index} className="col-xxl-3 col-xl-4 col-lg-6 col-12 mb-3">
                                <NormalSocialMediaCard image={socialMediaItem.image} name={socialMediaItem.name}
                                                       id={socialMediaItem.id} follower={socialMediaItem.follower}
                                                       places={socialMediaItem.places} cardID={index}
                                                       activateSocialMedia={socialMediaItem.activateSocialMedia}
                                                       setActivateSocialMedia={socialMediaItem.setActivateSocialMedia}/>
                            </div>
                        );
                    })
                }
            </div>
            <HorizontalDivider/>
        </div>
    );
}

export default Tab1;